<template>
  <q-page padding>
    <q-card class="md-card q-mt-lg q-pa-lg relative-position" color="white" text-color="black">
      <q-card-title>
        <h4>AGC-MN Privacy Policy</h4>
      </q-card-title>
      <q-card-separator/>
      <q-card-main>
        <div class="row">
          <div class="col-sm-12 l-lg-pad r-lg-pad">

            <p>This Privacy Policy describes how and what personal information Associated General Contractors of
              Minnesota (AGC-MN) collects, uses and shares when you visit
              or make a purchase from https://agcmn.org (the “Site”).</p>
            <h5>Information Collection </h5>
            <p>When you visit the Site, we automatically collect certain information about your device, including
              information about your web browser, IP address, time zone, and some of the cookies that are installed on
              your device. Additionally, as you browse the Site, we collect information about the individual web pages
              or products that you view, what websites or search terms referred you to the Site, and information about
              how you interact with the Site. We refer to this automatically-collected information as “Device
              Information.”</p>
            <ul>
              <li>Your name, email address, and contact information</li>
              <li>Your credit card details and applicable billing information</li>
              <li>Credentials to services that you use (third-party services)</li>
              <li>Any other information that you put into our support portal account.</li>
            </ul>
            <h5>Information Collection Methods</h5>
            <p>“Cookies” are data files that are placed on your device or computer and often include an anonymous unique
              identifier. For more information about cookies, and how to disable cookies, visit
              http://www.allaboutcookies.org. For more information, please refer to our Cookie Policy</p>
            <p>“Log files” track actions occurring on the Site, and collect data including your IP address, browser
              type, Internet service provider, referring/exit pages, and date/time stamps. </p>
            <p>“Web beacons,” “tags,” and “pixels” are electronic files used to record information about how you browse
              the Site.</p>
            <p>Additionally, when you make a purchase or attempt to make a purchase through our online store, we collect
              certain information from you, including your name, billing address, payment information (including credit
              card numbers), email address, and phone number. We refer to this information as “Order Information.”</p>
            <h5>How Do We Use Your Information?</h5>
            <p>We use the Order Information that we collect generally to activate paid subscriptions placed through the
              Online Store (including processing your payment information, arranging for monthly or annual billing, and
              providing you with invoices and/or order confirmations). Additionally, we use this Order Information
              to:</p>
            <ul>
              <li>Communicate with you;</li>
              <li>Schedule recurring monthly or annual billing;</li>
              <li>Collect payments from you;</li>
              <li>Screen our orders for potential risk or fraud; and</li>
              <li>When in line with the preferences you have shared with us, provide you with information or advertising
                relating to our products or services.
              </li>
            </ul>
            <p>We use the Device Information that we collect to help us screen for potential risk and fraud (for
              example, your IP address), and more generally to improve and optimize our Site (for example, by generating
              analytics about how our customers browse and interact with the Site, and to assess the success of our
              marketing and advertising campaigns). </p>
            <p>In addition, we may use your information to do the following:</p>
            <ul>
              <li>Administer service of our product offerings;</li>
              <li>Administer service to our support portal(s);</li>
              <li>Enable your access to and use of the third-party web services;</li>
              <li>Send you service updates.</li>
            </ul>
            <h5>Sharing Your Personal Information</h5>
            <p>We share your Personal Information with third parties to help us use your Personal Information, as
              described above. For example, we use a third-party serviced called Google Analytics to help us understand
              how our customers use the Site--you can
              read more about how Google uses your Personal Information here:
              https://www.google.com/intl/en/policies/privacy/. You can also opt-out of Google Analytics here:
              https://tools.google.com/dlpage/gaoptout.</p>
            <p>Finally, we may also share your Personal Information to comply with applicable laws and regulations, to
              respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise
              protect our rights. </p>
            <h5>Securing Your Data</h5>
            <p>AGC-MN will take reasonable technical and organizational precautions to prevent the loss or misuse of
              your saved order and personal information.</p>
            <p>AGC-MN will store all the personal information you provide on its secure servers apart from your credit
              card details. We use our secure payment partner (Quickbooks Payments:
              https://quickbooks.intuit.com/payments/) to process these payments and we do not have
              access to your card.</p>
            <h5>Do Not Track</h5>
            <p>Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track
              signal from your browser.</p>
            <h5>Minors</h5>
            <p>The Site is not intended for individuals under the age of 18.</p>
            <h5>Changes to This Document</h5>
            <p>AGC-MN may at any time, without notice to you, and in its sole discretion, update this
              privacy policy from time to time in order to reflect, for example, changes to our practices or for other
              operational, legal or regulatory reasons. Please review this policy periodically. </p>
            <p>AGC-MN is not responsible for the privacy policies or practices of any third party. </p>
            <h5>Contact AGC-MN</h5>
            <p>If you have any questions about this privacy policy, AGC-MN’ treatment of your information,
              or wish to submit a request to delete your information, please send e-mail to: info@agcmn.org. </p>
          </div>
        </div>
      </q-card-main>
    </q-card>
    <router-view></router-view>
  </q-page>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style></style>
